import gql from 'graphql-tag'

export default gql`mutation go($data: SystemSettingInput!){
  upsertSystemSetting(data: $data){
    id
    description
    setting_type_id
    setting_value
  }
}`